// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErNiPFNVWWpQAXJNzvbb {
  padding: 26px;
  background-color: #fff;
}

.tGi719fTZ6PtH9FR5ixi {
  border-radius: 50%;
  border: 4px solid #F27474;
  box-sizing: content-box;
  height: 80px;
  padding: 0;
  position: relative;
  background-color: #fff;
  width: 80px;
  animation: n2zqXI4zBPqtCEv0WVmo .5s;
}

.tGi719fTZ6PtH9FR5ixi::after, .tGi719fTZ6PtH9FR5ixi::before {
  background: #fff;
  content: '';
  height: 120px;
  position: absolute;
  transform: rotate(45deg);
  width: 60px;
}

.tGi719fTZ6PtH9FR5ixi::before {
  border-radius: 40px 0 0 40px;
  width: 26px;
  height: 80px;
  top: -17px;
  left: 5px;
  transform-origin: 60px 60px;
  transform: rotate(-45deg);
}

.tGi719fTZ6PtH9FR5ixi::after {
  border-radius: 0 120px 120px 0;
  left: 30px;
  top: -11px;
  transform-origin: 0 60px;
  transform: rotate(-45deg);
  animation: Z0cjSbMjZ2xctwve_7yZ 4.25s ease-in;
}


.A9sHlvIZfwPMgetZQfAu {
  display: block;
  position: relative;
  z-index: 2;
}

.tdASXS9oGcs7xxvvw8OW {
  border-radius: 50%;
  border: 4px solid rgba(200, 0, 0, .2);
  box-sizing: content-box;
  height: 80px;
  left: -4px;
  position: absolute;
  top: -4px;
  width: 80px;
  z-index: 2;
}

._X29BXKLxEsHgYlPqZ9g {
  background-color: #fff;
  height: 90px;
  left: 28px;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 5px;
  z-index: 1;
}

.IfCFoLXjz_TmfVN6l12N, .WX3K7Oi2E32BQkprbqJv {
  border-radius: 2px;
  display: block;
  height: 5px;
  position: absolute;
  z-index: 2;
  background-color: #F27474;
  top: 37px;
  width: 47px;
}

.IfCFoLXjz_TmfVN6l12N {
  left: 17px;
  transform: rotate(45deg);
  animation: MEhptPAcY6hXO0w60adw .75s;
}

.WX3K7Oi2E32BQkprbqJv {
  right: 16px;
  transform: rotate(-45deg);
  animation: iyol4bKApGkzdxCAohmF .75s;
}

@keyframes Z0cjSbMjZ2xctwve_7yZ {
  0%, 5% {
    transform: rotate(-45deg);
  }
  100%,12% {
    transform: rotate(-405deg);
  }
}
@keyframes n2zqXI4zBPqtCEv0WVmo {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
@keyframes MEhptPAcY6hXO0w60adw {
  0%, 65% {
    left: 82px;
    top: 95px;
    width: 0;
  }
  84% {
    left: 14px;
    top: 33px;
    width: 47px;
  }
  100% {
    left: 17px;
    top: 37px;
    width: 47px;
  }
}
@keyframes iyol4bKApGkzdxCAohmF {
  0%, 65% {
    right: 82px;
    top: 95px;
    width: 0;
  }
  84% {
    right: 14px;
    top: 33px;
    width: 47px;
  }
  100% {
    right: 16px;
    top: 37px;
    width: 47px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/ErrorAnimation/ErrorAnimation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,mCAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,6CAA0C;AAC5C;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,oCAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oCAA6B;AAC/B;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,SAAS;IACT,QAAQ;EACV;EACA;IACE,UAAU;IACV,SAAS;IACT,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,SAAS;IACT,QAAQ;EACV;EACA;IACE,WAAW;IACX,SAAS;IACT,WAAW;EACb;EACA;IACE,WAAW;IACX,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":[".icon {\n  padding: 26px;\n  background-color: #fff;\n}\n\n.iconError {\n  border-radius: 50%;\n  border: 4px solid #F27474;\n  box-sizing: content-box;\n  height: 80px;\n  padding: 0;\n  position: relative;\n  background-color: #fff;\n  width: 80px;\n  animation: animateErrorIcon .5s;\n}\n\n.iconError::after, .iconError::before {\n  background: #fff;\n  content: '';\n  height: 120px;\n  position: absolute;\n  transform: rotate(45deg);\n  width: 60px;\n}\n\n.iconError::before {\n  border-radius: 40px 0 0 40px;\n  width: 26px;\n  height: 80px;\n  top: -17px;\n  left: 5px;\n  transform-origin: 60px 60px;\n  transform: rotate(-45deg);\n}\n\n.iconError::after {\n  border-radius: 0 120px 120px 0;\n  left: 30px;\n  top: -11px;\n  transform-origin: 0 60px;\n  transform: rotate(-45deg);\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n\n.iconErrorX {\n  display: block;\n  position: relative;\n  z-index: 2;\n}\n\n.iconErrorPlaceholder {\n  border-radius: 50%;\n  border: 4px solid rgba(200, 0, 0, .2);\n  box-sizing: content-box;\n  height: 80px;\n  left: -4px;\n  position: absolute;\n  top: -4px;\n  width: 80px;\n  z-index: 2;\n}\n\n.iconErrorFix {\n  background-color: #fff;\n  height: 90px;\n  left: 28px;\n  position: absolute;\n  top: 8px;\n  transform: rotate(-45deg);\n  width: 5px;\n  z-index: 1;\n}\n\n.iconErrorLeft, .iconErrorRight {\n  border-radius: 2px;\n  display: block;\n  height: 5px;\n  position: absolute;\n  z-index: 2;\n  background-color: #F27474;\n  top: 37px;\n  width: 47px;\n}\n\n.iconErrorLeft {\n  left: 17px;\n  transform: rotate(45deg);\n  animation: animateXLeft .75s;\n}\n\n.iconErrorRight {\n  right: 16px;\n  transform: rotate(-45deg);\n  animation: animateXRight .75s;\n}\n\n@keyframes rotatePlaceholder {\n  0%, 5% {\n    transform: rotate(-45deg);\n  }\n  100%,12% {\n    transform: rotate(-405deg);\n  }\n}\n@keyframes animateErrorIcon {\n  0% {\n    transform: rotateX(100deg);\n    opacity: 0;\n  }\n  100% {\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n@keyframes animateXLeft {\n  0%, 65% {\n    left: 82px;\n    top: 95px;\n    width: 0;\n  }\n  84% {\n    left: 14px;\n    top: 33px;\n    width: 47px;\n  }\n  100% {\n    left: 17px;\n    top: 37px;\n    width: 47px;\n  }\n}\n@keyframes animateXRight {\n  0%, 65% {\n    right: 82px;\n    top: 95px;\n    width: 0;\n  }\n  84% {\n    right: 14px;\n    top: 33px;\n    width: 47px;\n  }\n  100% {\n    right: 16px;\n    top: 37px;\n    width: 47px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `ErNiPFNVWWpQAXJNzvbb`,
	"iconError": `tGi719fTZ6PtH9FR5ixi`,
	"animateErrorIcon": `n2zqXI4zBPqtCEv0WVmo`,
	"rotatePlaceholder": `Z0cjSbMjZ2xctwve_7yZ`,
	"iconErrorX": `A9sHlvIZfwPMgetZQfAu`,
	"iconErrorPlaceholder": `tdASXS9oGcs7xxvvw8OW`,
	"iconErrorFix": `_X29BXKLxEsHgYlPqZ9g`,
	"iconErrorLeft": `IfCFoLXjz_TmfVN6l12N`,
	"iconErrorRight": `WX3K7Oi2E32BQkprbqJv`,
	"animateXLeft": `MEhptPAcY6hXO0w60adw`,
	"animateXRight": `iyol4bKApGkzdxCAohmF`
};
export default ___CSS_LOADER_EXPORT___;
